const fetchGetInfoCategory = async (category_slug:string) => {
    var data: any = ''
    try {
        const response = await fetch(`/wp-json/v1/product-category/${category_slug}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
  
        });
        data =  {data : await response.json(), status: response.status};
    } catch {
        return false
    }
    // console.log(data);
    return data
  }
  export default fetchGetInfoCategory;